import { render, staticRenderFns } from "./Front.vue?vue&type=template&id=673f47b0&scoped=true&"
import script from "./Front.vue?vue&type=script&lang=ts&"
export * from "./Front.vue?vue&type=script&lang=ts&"
import style0 from "./Front.vue?vue&type=style&index=0&id=673f47b0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673f47b0",
  null
  
)

export default component.exports